import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import profileEditIcon from 'assets/images/icons/profile-edit-green-icon.svg';

import Badge from './Badge';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';

const BadgesWithSelection = ({
  name,
  displayName,
  hintText,
  icon,
  optionList,
  selectedList,
  handleChange,
}) => {
  const { t } = useTranslation();

  const selectedOptions = optionList.filter((o) => selectedList.includes(o.value));
  return (
    <div>
      {displayName && (
        <label htmlFor={name} className='mb-1'>
          {t(displayName)}
        </label>
      )}
      <div className='theme-background-white-1 d-flex justify-content-between align-items-center p-2 rounded-sm'>
        <div className='d-flex gap-2'>
          {icon && <img src={icon} />}
          {selectedOptions.length > 0 ? (
            <div className='d-flex gap-2'>
              {selectedOptions.slice(0, 2).map((o, i) => (
                <Badge key={i} text={o.displayValue} variant='grey-2' />
              ))}
              {selectedOptions.length > 2 && (
                <Badge text={`+ ${selectedOptions.length - 2}`} variant='grey-2' />
              )}
            </div>
          ) : (
            <>{hintText && <label className='theme-size-0_9'>{t(hintText)}</label>}</>
          )}
        </div>
        <div>
          <MultiLevelSelect
            options={{ children: optionList, selectMultiple: true, searchable: true }}
            value={selectedList}
            name={name}
            handleChange={handleChange}
            align='end'
            classes='theme-font-jakartaSans-regular'
            toggleClasses='d-flex gap-2 justify-content-between align-items-center cursor-pointer user-select-none'
            toggleComponent={
              <>
                <label className='theme-size-0_9 cursor-pointer'>Admin Profiles</label>
                <img src={profileEditIcon} />
              </>
            }
          />
        </div>
      </div>
    </div>
  );
};

BadgesWithSelection.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  hintText: PropTypes.string,
  icon: PropTypes.string,
  optionList: PropTypes.array.isRequired,
  selectedList: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default BadgesWithSelection;
